import dynamic from "next/dynamic";
import { robotoSlab } from "/utils/fonts";

const Grid = dynamic(() => import("@mui/material/Grid"), { loading: () => null });
const MDBox = dynamic(() => import('/components/MDBox'), { loading: () => null });
const MDTypography = dynamic(() => import('/components/MDTypography'), { loading: () => null });

export default function DialogAboutDisplay({ array, keyPrefix }) {
  return (
    <MDBox position="relative" zIndex={10} px={{ xs: 1, sm: 0 }} mt={16}>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={6}>
          {array !== undefined && array.map((row, rowIndex) => {
            if (row.type === "title") return (
              <MDTypography variant="h3" component="h2" mb={2} key={rowIndex} className={robotoSlab.className}>
                {row.value}
              </MDTypography>
            );
            if (row.type === "heading") return (
              <MDTypography variant="h5" component="h3" mb={2} key={rowIndex} className={robotoSlab.className}>
                {row.value}
              </MDTypography>
            );
            if (row.type === "paragraph") return (
              <MDTypography variant="body2" fontWeight="regular" component="p" mb={2} key={rowIndex}>
                {row.value}
              </MDTypography>
            );
            if (row.type === "list") return (
              <ul style={{ paddingLeft: "24px", color: "#808080", fontSize: 14 }} key={`ol-${rowIndex}`}>
                {row.value.map((line, listItemIndex) => (
                  <li key={`${rowIndex}-${listItemIndex}`}>
                      <MDTypography variant="body2" fontWeight="regular" component="div" mb={2} key={`ol-${rowIndex}-li-${listItemIndex}`}>
                        {line.value}
                      </MDTypography>
                  </li>
                ))}
              </ul>
            );
            return null;
          })}
        </Grid>
      </Grid>
    </MDBox>
  )
}